import type { UserContext } from "@/lib/rbac";

/**
 * May this session start docs generation? POST /workflows/:id/generate-docs
 * needs workflows.update, which operator and viewer lack, so opening the docs
 * panel as either must not fire a request that can only 403 (UX rule 6).
 *
 * Deny-list, like canManageConnections: a custom role (`cr_<uuid>`) is not
 * stripped of it, and an unresolved role (which falls back to "viewer") is
 * not treated as read-only on a guess.
 */
export function canGenerateDocs(ctx: Pick<UserContext, "role" | "roleResolved"> | null | undefined): boolean {
  if (!ctx) return false;
  return !(ctx.roleResolved === true && (ctx.role === "viewer" || ctx.role === "operator"));
}
